export const PART_OUT_OF_STOCK_THRESHOLD = 1410065408;

export const PNET_APP_QUERY_PARAM = 'appName=PNET';

export const PNET_GOP_BATCH_SIZE = 50;

export const PARTS_CATEGORY_NAME = 'parts & accessories';

export const INTERNATIONAL_ZIP_CODE = '00000';

//PNT-72
export const INTERNATIONAL_CUSTOMER_SUBCLASSES = [
  'PARTS-EXL',
  'PARTS-EXE',
  'PARTS-EXA',
  'PARTS-EX1',
  'PARTS-EX2',
  'PARTS-PRO',
  'PARTS-PDE',
] as const;

//PNT-1
export const FREIGHT_DOCUMENT_SUBCLASSES = [
  'PARTS-AW5',
  'PARTS-AWA',
  'PARTS-AWB',
  'PARTS-AWD',
  'PARTS-AWE',
  'PARTS-AWG',
  'PARTS-AWP',
  'PARTS-AWR',
  'PARTS-AWU',
  'PARTS-AWW',
  'PARTS-EX1',
  'PARTS-EX2',
  'PARTS-EXA',
  'PARTS-EXE',
  'PARTS-EXL',
  'PARTS-PD0',
  'PARTS-PD1',
  'PARTS-PD3',
  'PARTS-PDA',
  'PARTS-PDE',
  'PARTS-PDH',
  'PARTS-PDR',
  'PARTS-PDT',
  'PARTS-PRO',
] as const;

//PNT-228
export const MULTI_PACK_DOCUMENT_SUBCLASSES = [
  'PARTS-PD0',
  'PARTS-PD1',
  'PARTS-PDT',
] as const;

//PNT-25
export const POK_ENABLED_SUBCLASSES = ['PARTS-AW6', 'PARTS-AW9'] as const;

//PNT-20
export const MODIFIERS_EXCLUDED_FROM_VOLUME_DISCOUNT = [
  'PARTS -  DFI - CUSTOMER CLASS PROMOTIONS',
  'PARTS - DFI - CUSTOMER PROMOTIONS',
] as const;

export const SKUS_EXCLUDED_FROM_VOLUME_DISCOUNT = ['WXCORE01'];

//PNT-84
export const PARTS_SHIP_METHODS = {
  international: {
    regular: [
      {
        code: 'GRFX',
        displayName: 'Ground',
        ebsShipMethodName: 'Parts-FEDEX-Ground 1 - 7 Days',
      },
    ],
    emergency: [
      {
        code: 'SDFX',
        displayName: 'Air',
        ebsShipMethodName: 'Parts-FEDEX-2nd Day Air',
      },
      {
        code: 'GRFX',
        displayName: 'Ground',
        ebsShipMethodName: 'Parts-FEDEX-Ground 1 - 7 Days',
      },
    ],
  },
  domestic: {
    regular: [
      {
        code: 'GRFX',
        displayName: 'Ground-Commercial',
        ebsShipMethodName: 'Parts-FEDEX-Ground 1 - 7 Days',
        message: 'Estimated delivery: 3–7 business days',
      },
      // {
      //   code: 'GRFX',
      //   displayName: 'Ground-Residential',
      //   ebsShipMethodName: 'Parts-FEDEX-HD1-5 Days',
      // },
    ],
    emergency: [
      // {
      //   code: 'NDFX',
      //   displayName: 'Overnight',
      //   ebsShipMethodName: 'Parts-FEDEX-Priority Overnight',
      // },
      {
        code: 'NDFX',
        displayName: 'Next Day',
        ebsShipMethodName: 'Parts-FEDEX-Next Day',
        message:
          'Orders must be submitted by 1PM EST to qualify for next day processing',
      },
      // {
      //   code: 'SDFX',
      //   displayName: 'Second Day',
      //   ebsShipMethodName: 'Parts-FEDEX-2nd Day Air',
      // },
      {
        code: 'GRFX',
        displayName: 'Ground',
        ebsShipMethodName: 'Parts-FEDEX-Ground 1 - 7 Days',
        message: 'Estimated delivery: 3–7 business days',
      },
    ],
  },
} as const;

//PNT-149
export const SHIPPING_PRIORITIES = {
  RT: 'RT-Regular-One Shipment-Parts',
  ET: 'ET-Emergency-One Shipment-Parts',
  RZ: 'RZ-Regular-Multiple Shipments-Parts',
  EZ: 'EZ-Emergency-Multiple Shipment-Parts',
} as const;

//PNT-164
export const SEAL_CODE_TO_CARRIER = {
  'GR-A': 'AVERITT EXPRESS',
  'GR-AD': 'A DUIE PYLE',
  'GR-BC': 'Best Courier',
  'GR-BE': 'Best Dedicated',
  'GR-CO': 'Cornerstone',
  'GR-CR': 'CRST',
  'GR-CT': 'Central Transport',
  'GR-CT RVR': 'Central Transport RVR',
  'GR-CY': 'Coyote',
  'GR-DA': 'DAYTON FREIGHT',
  'GR-DA RVR': 'DAYTON FREIGHT RVR CARRIER',
  'GR-DG': 'Dedicated Carrier Global Services',
  'EX-EX': 'Export',
  'GR-FF': 'FED EX FREIGHT',
  '3D-FX': 'FedEx-3 Day Shipment',
  'GR-FX': 'FedEx-Ground',
  'H3-FX': 'FedEx-Ground Home Delivery',
  'ND-FX': 'FedEx- Standard Overnight (Next Day)',
  'PO-FX': 'Fed Ex Priority Overnight',
  'SA-FX': 'Fed Ex Standard Overnight',
  'SD-FX': 'FedEx-2Day',
  'SP-FX': 'FedEx- Smartpost Parcel Select',
  'SU-FX': 'FedEx- Smartpost Lightweight',
  'TD-FX': 'FedEx- 2Day Air',
  'GR-HU': 'Hub Group',
  'GR-JH': 'JB HUNT',
  'GR-JJ': 'J AND J',
  'TB-LT': 'LT',
  'GR-LTL': 'LTL',
  'GR-MA': 'Magellan Logistics',
  'GR-MM': 'M AND M CARTAGE',
  'GR-MP': 'Mister P Express',
  'SP-PB': 'Pitney Bowes USPS Parcel Select',
  'SU-PB': 'Pitney Bowes USPS Parcel Select Lightweight',
  'GR-PD': 'PRODUCT DISTRIBUTION',
  'AF-PF': 'Pilot-Air Freight',
  'PM-PM': 'USPS Priority Mail',
  'GR-PO': 'Pitt Ohio',
  'GR-RO': 'CH Robinson',
  'GR-RR': 'RR',
  'GR-RR RVR': 'ROAD RUNNER rvr',
  'GR-RV': 'RVR',
  'WMS-RVR': 'RVR',
  'GR-SA': 'Saia',
  'GR-SU': 'Summit Trucking',
  'GR-TR': 'Transport America',
  'GR-TS': 'Transit Solutions Inc.',
  '3D-UD': 'UPS 3 Day',
  'GR-UD': 'UPS Sears-Ground',
  'ND-UD': 'UPS Next Day Air',
  'PO-UD': 'UPS-1Day',
  'SD-UD': 'UPS-2Day',
  'TD-UD': 'UPS Sears-2Day',
  'GR-UU': 'UPS Ground',
  'WC-WC': 'Will Call',
  'GR-WM': 'RVR',
  'GR-WO': 'Worldwide Logistics',
  'GR-XP': 'XPO Logistics Freight Inc',
  'GR-XP RVR': 'XPO Logistics Freight Inc',
  'GR-YR': 'YRC Yellow Roadway',
} as const;

//PNT-292
export const CARRIER_CODE_TO_TRACKING_URL = {
  A: 'https://tools.averitt.com/tracking/trackLTLById?toolTab=track&serviceType=LTL&resultsPageTitle=LTL+Tracking+by+PRO+and+BOL&searchType=LTL&trackPro=<TRACKING_NUMBER>',
  DA: 'https://tools.daytonfreight.com/tracking/detail/<TRACKING_NUMBER>',
  FX: 'https://www.fedex.com/fedextrack/?trknbr=<TRACKING_NUMBER>',
  UD: 'https://www.ups.com/track?track=yes&trackNums=<TRACKING_NUMBER>',
  XP: 'https://ext-web.ltl-xpo.com/public-app/shipments?referenceNumber=<TRACKING_NUMBER>',
} as const;

//PNT-117
export const EBS_LINE_STATUS_MAP = {
  AWAITING_FULFILLMENT: 'Shipped',
  AWAITING_RECEIPT: 'Picked',
  AWAITING_SHIPPING: 'Awaiting Shipping',
  BOOKED: 'Booked',
  CANCELLED: 'Cancelled',
  CLOSED: 'Shipped',
  ENTERED: 'Entered',
  FULFILLED: 'Shipped',
  PICKED: 'Picked',
} as const;
